import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const options = {
  name: 'test-questions',
};

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      flexGrow: 2,
      position: 'relative',
      minHeight: 600,
    },
    container: {
      // padding: theme.spacing(4, 12.5, 4, 6.75),
      padding: theme.spacing(2, 0),
      position: 'absolute',
      width: '100%',
      height: '100%',
      overflow: 'auto',
      '& .simplebar-content-wrapper': {
        scrollBehavior: 'smooth',
      },
    },
    scrollContent: {},
  }),
  options
);

export default useStyles;
